import React, { useState } from "react";
import {
  Form,
  Button,
  Container,
  Alert,
  Modal,
  Table,
  Row,
  Col,
} from "react-bootstrap";
import SidebarLayout from "../../components/sidebarLayout";
import menuData from "../../data/menuData";
import axios from "axios"; // axios 추가
import "./register.css";

export default function Register() {
  const [formData, setFormData] = useState({
    memberType: "REGULAR", // 회원 구분
    userType: "USER",
    nameKor: "",
    nameEng: "",
    birthDate: "",
    email: "",
    password: "", // 비밀번호 추가
    confirmPassword: "", // 비밀번호 확인 추가
    organization: "",
    position: "",
    address: "",
    phone: "",
  });

  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false); // 로딩 상태 추가\
  const [termsAccepted, setTermsAccepted] = useState(false); // 약관 동의 상태
  const [privacyAccepted, setPrivacyAccepted] = useState(false); // 개인정보처리 동의 상태

  const [education, setEducation] = useState([
    { year: "", month: "", details: "" },
  ]);
  const [experience, setExperience] = useState([
    { year: "", month: "", details: "" },
  ]);

  const memberMenu = menuData.find((menu) => menu.title === "회원안내");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleAddRow = (type) => {
    if (type === "education") {
      setEducation([...education, { year: "", month: "", details: "" }]);
    } else if (type === "experience") {
      setExperience([...experience, { year: "", month: "", details: "" }]);
    }
  };

  const handleRemoveRow = (type, index) => {
    if (type === "education") {
      setEducation(education.filter((_, i) => i !== index));
    } else if (type === "experience") {
      setExperience(experience.filter((_, i) => i !== index));
    }
  };

  const handleInputChange = (type, index, field, value) => {
    const updater = type === "education" ? setEducation : setExperience;
    const data = type === "education" ? [...education] : [...experience];
    data[index][field] = value; // 직접 값을 할당
    updater(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { nameKor, email, password, confirmPassword } = formData;

    // 필수 입력 필드 확인
    if (!nameKor || !email || !password || !confirmPassword) {
      setError("필수 입력 항목을 모두 채워주세요.");
      return;
    }

    // 비밀번호와 비밀번호 확인 일치 여부 확인
    if (password !== confirmPassword) {
      setError("비밀번호가 일치하지 않습니다.");
      return;
    }

    // 약관 및 개인정보처리 동의 확인
    if (!termsAccepted || !privacyAccepted) {
      setError("약관 및 개인정보처리방침에 동의해야 합니다.");
      return;
    }

    // 초기값을 포함하여 데이터 준비
    const requestData = {
      ...formData,
      educations: education
        .map((edu) => {
          if (!edu.year && !edu.month && !edu.details) return null; // 모두 비어있으면 제외
          return {
            year: edu.year || null, // 비어있으면 null로 전송
            month: edu.month || null,
            details: edu.details || "",
          };
        })
        .filter(Boolean), // 유효하지 않은 항목 제외
      experiences: experience
        .map((exp) => {
          if (!exp.year && !exp.month && !exp.details) return null;
          return {
            year: exp.year || null,
            month: exp.month || null,
            details: exp.details || "",
          };
        })
        .filter(Boolean),
    };

    try {
      setError("");
      setLoading(true); // 로딩 상태 활성화
      console.log("requestData", requestData);
      const response = await axios.post("/api/user/register", requestData); // 실제 서버 엔드포인트로 요청 전송
      console.log("서버 응답:", response.data);
      setShowSuccessModal(true); // 성공 모달 표시
    } catch (err) {
      console.error("회원가입 요청 실패:", err.response?.data || err.message);
      setError(
        err.response?.data?.resultMessage ||
          "회원가입 요청 중 문제가 발생했습니다."
      );
    } finally {
      setLoading(false); // 로딩 상태 비활성화
    }
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
    window.location.reload();
  };

  return (
    <div>
      <SidebarLayout menu={memberMenu}>
        <Container className="my-5">
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Table bordered>
              <tbody>
                <tr>
                  <td>
                    회원구분
                    <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  </td>
                  <td colSpan="3">
                    <Form.Check
                      inline
                      label="정회원"
                      type="radio"
                      name="memberType"
                      value="REGULAR"
                      checked={formData.memberType === "REGULAR"}
                      onChange={handleChange}
                    />
                    <Form.Check
                      inline
                      label="준회원"
                      type="radio"
                      name="memberType"
                      value="ASSOCIATE"
                      checked={formData.memberType === "ASSOCIATE"}
                      onChange={handleChange}
                    />
                    <Form.Check
                      inline
                      label="단체회원"
                      type="radio"
                      name="memberType"
                      value="GROUP"
                      checked={formData.memberType === "GROUP"}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    성명
                    <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  </td>
                  <td>
                    <Form.Control
                      type="text"
                      placeholder="한글 이름"
                      name="nameKor"
                      value={formData.nameKor}
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="text"
                      placeholder="영문 이름"
                      name="nameEng"
                      value={formData.nameEng}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>생년월일</td>
                  <td colSpan="3">
                    <Form.Control
                      type="date"
                      name="birthDate"
                      value={formData.birthDate}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    E-mail
                    <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  </td>
                  <td colSpan="3">
                    <Form.Control
                      type="email"
                      placeholder="이메일을 입력하세요"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    비밀번호
                    <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  </td>
                  <td colSpan="3">
                    <Form.Control
                      type="password"
                      placeholder="비밀번호를 입력하세요"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    비밀번호 확인
                    <span style={{ color: "red", marginLeft: "5px" }}>*</span>
                  </td>
                  <td colSpan="3">
                    <Form.Control
                      type="password"
                      placeholder="비밀번호를 다시 입력하세요"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td>소속기관</td>
                  <td>
                    <Form.Control
                      type="text"
                      placeholder="기관명"
                      name="organization"
                      value={formData.organization}
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <Form.Control
                      type="text"
                      placeholder="직위"
                      name="position"
                      value={formData.position}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>주소</td>
                  <td colSpan="3">
                    <Form.Control
                      type="text"
                      placeholder="소속기관 주소"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>전화</td>
                  <td colSpan="3">
                    <Form.Control
                      type="text"
                      placeholder="소속기관 전화"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>

            {/* 학력사항 */}
            <h5>학력사항</h5>
            {education.map((edu, index) => (
              <Row key={index} className="align-items-center mb-3">
                <Col md={2} className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    placeholder="YYYY"
                    value={edu.year}
                    maxLength="4"
                    onChange={(e) =>
                      handleInputChange(
                        "education",
                        index,
                        "year",
                        e.target.value
                      )
                    }
                  />
                  <span className="ms-2">년</span>
                </Col>
                <Col md={2} className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    placeholder="MM"
                    value={edu.month}
                    maxLength="2"
                    onChange={(e) =>
                      handleInputChange(
                        "education",
                        index,
                        "month",
                        e.target.value
                      )
                    }
                  />
                  <span className="ms-2">월</span>
                </Col>
                <Col md={6}>
                  <Form.Control
                    type="text"
                    placeholder="학력사항 입력"
                    value={edu.details}
                    onChange={(e) =>
                      handleInputChange(
                        "education",
                        index,
                        "details",
                        e.target.value
                      )
                    }
                  />
                </Col>
                <Col md={2} className="d-flex justify-content-end">
                  {education.length > 1 && (
                    <Button
                      variant="danger"
                      className="me-2"
                      onClick={() => handleRemoveRow("education", index)}
                    >
                      삭제
                    </Button>
                  )}
                  <Button
                    variant="primary"
                    onClick={() => handleAddRow("education")}
                  >
                    추가
                  </Button>
                </Col>
              </Row>
            ))}

            {/* 경력사항 */}
            <h5>경력사항</h5>
            {experience.map((exp, index) => (
              <Row key={index} className="align-items-center mb-3">
                <Col md={2} className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    placeholder="YYYY"
                    value={exp.year}
                    maxLength="4"
                    onChange={(e) =>
                      handleInputChange(
                        "experience",
                        index,
                        "year",
                        e.target.value
                      )
                    }
                  />
                  <span className="ms-2">년</span>
                </Col>
                <Col md={2} className="d-flex align-items-center">
                  <Form.Control
                    type="text"
                    placeholder="MM"
                    value={exp.month}
                    maxLength="2"
                    onChange={(e) =>
                      handleInputChange(
                        "experience",
                        index,
                        "month",
                        e.target.value
                      )
                    }
                  />
                  <span className="ms-2">월</span>
                </Col>
                <Col md={6}>
                  <Form.Control
                    type="text"
                    placeholder="경력사항 입력"
                    value={exp.details}
                    onChange={(e) =>
                      handleInputChange(
                        "experience",
                        index,
                        "details",
                        e.target.value
                      )
                    }
                  />
                </Col>
                <Col md={2} className="d-flex justify-content-end">
                  {experience.length > 1 && (
                    <Button
                      variant="danger"
                      className="me-2"
                      onClick={() => handleRemoveRow("experience", index)}
                    >
                      삭제
                    </Button>
                  )}
                  <Button
                    variant="primary"
                    onClick={() => handleAddRow("experience")}
                  >
                    추가
                  </Button>
                </Col>
              </Row>
            ))}

            {/* 약관 및 개인정보처리방침 동의 */}
            <Form.Group controlId="termsAndConditions" className="mb-3">
              <Form.Check
                type="checkbox"
                checked={termsAccepted}
                onChange={(e) => setTermsAccepted(e.target.checked)}
                label={
                  <span>
                    <a
                      href="/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#1769b3 !important",
                        textDecoration: "underline !important",
                      }}
                    >
                      이용 약관
                    </a>
                    에 동의합니다.
                  </span>
                }
              />
            </Form.Group>
            <Form.Group controlId="privacyPolicy" className="mb-3">
              <Form.Check
                type="checkbox"
                checked={privacyAccepted}
                onChange={(e) => setPrivacyAccepted(e.target.checked)}
                label={
                  <span>
                    <a
                      href="/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#1769b3 !important",
                        textDecoration: "underline !important",
                      }}
                    >
                      개인정보 처리방침
                    </a>
                    에 동의합니다.
                  </span>
                }
              />
            </Form.Group>

            {/* 회원가입 버튼 */}
            <Button
              style={{
                backgroundColor: "#1769b3",
                borderColor: "#1769b3",
                color: "white",
              }}
              type="submit"
              className="w-100"
              disabled={loading} // 로딩 중일 때 버튼 비활성화
            >
              {loading ? "등록 중..." : "회원가입"}
            </Button>
          </Form>

          {/* 성공 모달 */}
          <Modal show={showSuccessModal} onHide={handleModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>회원가입 완료</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              회원가입이 완료되었습니다!<br></br>
              관리자 승인 후 로그인 가능합니다.
            </Modal.Body>
            <Modal.Footer>
              <Button
                style={{
                  backgroundColor: "#1769b3",
                  borderColor: "#1769b3",
                  color: "white",
                }}
                onClick={handleModalClose}
              >
                확인
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </SidebarLayout>
    </div>
  );
}
